<template>
  <div class="content">
    <h2 class='setpwd-title'>微信支付配置</h2>

    <el-form label-width="150px" :model="wxpayData" :rules="rules" ref="form" class="mt10">
      <el-form-item label="支付商户号" prop="mchId" >
        <el-input v-model="wxpayData.mchId" size='normal' style="width:70%;"></el-input>
      </el-form-item>

      <el-form-item label="微信支付证书" prop="certFile">
        <el-upload
          class="upload-demo"
          ref="upload"
          action="#"
          :on-change="handleChange"
          :on-remove="handleRemove"
          :file-list="fileList"
          v-model="wxpayData.certFile"
          :auto-upload="false">
          <el-button slot="trigger" width="70%" size="mini" type="primary" >选取文件</el-button>
        </el-upload>
        <p v-show="wxpayData.certFile">已上传</p>
      </el-form-item>

      <el-form-item label="调用IP地址" prop="ip">
        <!--<el-input v-model="ruleForm.ip"  type="text" :rows="2" width="120px"></el-input>-->
        <el-input type="textarea" v-model="wxpayData.ip" style="width:70%;" disabled="disabled" :row="3"></el-input>
        <el-button size="small" v-clipboard:copy="wxpayData.ip">复制</el-button>
      </el-form-item>
      <el-form-item label="API密钥" prop="wechatKey" >
        <el-input v-model="wxpayData.wechatKey" size='small' type="text" style="width:70%;"></el-input>
        <el-button size="small" v-clipboard:copy="wxpayData.wechatKey">复制</el-button>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" @click='submitForm()' class="submit">提交</el-button>
      </el-form-item>
    </el-form>


  </div>
</template>

<script>

export default {
  name: 'WechatPay',
  props: {
    propsWxpayData: Object
  },
  data() {
    return {
      wxpayData: {
        id: '',
        mchId: "",
        certFile: "",
        ip: "",
        wechatKey: '',
        wechatAppid:'',
        secretKey: ""
      },
      rules: {
        mchId: [{ required: true, message: "请输入支付商户号", trigger: "blur" }],
        certFile: [{ required: true, message: "请上传支付证书", trigger: "blur" }],
        secretKey: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      fileList: [],
      maxSize: 5
    };
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.wxpayData = {
        id: this.propsWxpayData.id,
        mchId: this.propsWxpayData.mchId,
        secretKey: this.propsWxpayData.secretKey,
        certFile: this.propsWxpayData.cert,
        wechatKey: this.propsWxpayData.wechatKey,
        ip: this.propsWxpayData.ip,
        wechatAppid:this.propsWxpayData.wechatAppid,
      }
    },
    handleRemove(file, fileList) {
      // 清空文件数据
      this.fileList = []
      this.wxpayData.certFile = ''
    },
    handleChange(file, fileList) {
      this.fileList = []
      const isP12 = file.raw.type === 'application/x-pkcs12';
      const isSize = file.size / 1024 > this.maxSize;
      if (!isP12) {
        this.fileList = []
        this.wxpayData.certFile = ''
        this.$message.error('上传文件只能是 p12 格式!');
        return
      }
      if (isSize) {
        this.$message.error('上传文件大小不能超过' + this.maxSize + 'kb!');
        return
      }
      // 控制文件只能上传一个
      this.fileList = fileList.slice(-1);
      let picurl = this.convertFileToBase64(file);
      return true;
    },
    convertFileToBase64(file) {
      // 传文件为base64格式
      let _this = this;
      var r = new FileReader();
        r.onload = function() {
        _this.wxpayData.certFile = r.result.split('base64,')[1]
      };
      r.readAsDataURL(file.raw);
    },
    // 保存
    setwxpay() {
      let data = {
        id: this.wxpayData.id,
        wechatKey: this.wxpayData.wechatKey,
        mchId	: this.wxpayData.mchId,
        cert: this.wxpayData.certFile
      }
      this.$store.dispatch("wxservicePaymentSettings", data).then((res) => {
        this.$message.success("提交成功");
        this.$emit('OnSuccess')
      });
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.setwxpay();
        } else {
          return false;
        }
      });
    }
  },
  watch: {
    propsWxpayData() {
      this.init()
    },
  },
};
</script>

<style scoped>
.content {
  padding: 20px;
}
.content h2 {
  margin-bottom: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mt-10 {
  margin: 10px 0;
}
.submit {
  margin-left: 114px;
}
.setpwd-title {
  text-align: center;
  font-size: 18px;
  color:rgba(54,61,177,1);
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// wechatPay.vue?992e9572